import { Typography } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

import styles from '../Intimidad/Intimidad.module.css';

export const WhatsAppForSurvey = ({ hasWhatsApp, handleHasWhatsApp }) => {
  return (
    <div className={styles.intimidad}>
      <div className={styles.top}>
        <Typography
          variant="h6"
          style={{ fontWeight: 'bold', marginBottom: '15px' }}
        >
          Envío de encuestas por medio de WhatsApp.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Desea que la encuesta se pueda enviar por WhatsApp.
        </Typography>
      </div>
      <div className={styles.bottom}>
        <FormControl>
          <FormControlLabel
            control={
              <Switch
                checked={hasWhatsApp}
                onChange={(e) => handleHasWhatsApp(e.target.checked)}
              />
            }
            label={
              hasWhatsApp
                ? 'Sí, quiero enviar la encuesta por WhatsApp.'
                : 'No, no quiero enviar la encuesta por WhatsApp.'
            }
          />
        </FormControl>
      </div>
    </div>
  );
};
